export const transformVideoThumb = (src: string) => {
  let transformedArr = src?.split('/') || '';
  const transformedLength = transformedArr.length;
  if (transformedLength > 1) {
    transformedArr[transformedLength - 2] = transformedArr[transformedLength - 2].concat('', '-preview');
    transformedArr[transformedLength - 1] = transformedArr[transformedLength - 1].replace('mp4', 'webp');
    return transformedArr.join('/');
  }
  return '';
};
